export default "__VITE_ASSET__DWHe9vu___"